import { Filter, RotateCcw, Search, ListOrdered, Download, Settings, Image } from "lucide-react";
import { useState, useEffect } from "react";
import { StatusFilterPhotoMeter, PhotoMeterItem } from "../../../../model/Hublang";
import { fetchGetPhotoMeterAll, fetchGetPhotoMeterTagihanAll } from "../../../../controller/dashboard/Cekmeter";
import { CSV } from "../../../../util/ExportFile";

export const KoreksiUmum = () => {
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // bisa default 
    const [statusFilter, setStatusFilter] = useState<StatusFilterPhotoMeter>({
        nama: 'all',
        nsb: 'all',
        kecamatan: 'all',
        desa: 'all',
        klasf: 'all',
        pelanggan: 'all',
        status: 'all',
        pakai: 'all',
        tahun: 'all'
    });

    
    const [statusLength, setStatusLength] = useState('10');
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [photoMeterData, setPhotoMeterData] = useState<PhotoMeterItem[]>([]);
    const [selectedPhotoMeter, setSelectedPhotoMeter] = useState<PhotoMeterItem | null>(null);

    const uniqueNsb = Array.from(new Set(photoMeterData.map(item => item.nsb))).filter(Boolean);
    const uniqueKecamatan = Array.from(new Set(photoMeterData.map(item => item.kecamatan))).filter(Boolean);
    const uniqueDesa = Array.from(new Set(photoMeterData.map(item => item.desa))).filter(Boolean);
    const uniqueKlas = Array.from(new Set(photoMeterData.map(item => item.klasf))).filter(Boolean);
    const uniquePelanggan = Array.from(new Set(photoMeterData.map(item => item.pelanggan))).filter(Boolean);
    const uniqueStatus = Array.from(new Set(photoMeterData.map(item => item.status))).filter(Boolean).sort((a, b) => Number(a) - Number(b));

  
    const filteredPhotoMeters = photoMeterData.filter(plg => {
      const matchesSearch =plg.nama.toLowerCase().includes(searchTerm.toLowerCase()) ||
        plg.nama.includes(searchTerm) ||
        plg.nsb.includes(searchTerm) ||
        plg.kecamatan.includes(searchTerm) ||
        plg.desa.includes(searchTerm) ||
        plg.klasf.includes(searchTerm) ||
        plg.pelanggan.includes(searchTerm) ||
        plg.status.includes(searchTerm) ||
        plg.pakai.includes(searchTerm) ||
        plg.tahun.includes(searchTerm)
  
      const matchesStatus = 
        (statusFilter.status === 'all' || plg.status === statusFilter.status) &&
        (statusFilter.nama === 'all' || plg.nama === statusFilter.nama) &&
        (statusFilter.nsb === 'all' || plg.nsb === statusFilter.nsb) &&
        (statusFilter.kecamatan === 'all' || plg.kecamatan === statusFilter.kecamatan) &&
        (statusFilter.pakai === 'all' || plg.pakai === statusFilter.pakai) &&
        (statusFilter.klasf === 'all' || plg.klasf === statusFilter.klasf) &&
        (statusFilter.pelanggan === 'all' || plg.pelanggan === statusFilter.pelanggan) &&
        (statusFilter.desa === 'all' || plg.desa === statusFilter.desa) &&
        (statusFilter.tahun === 'all' || plg.tahun === statusFilter.tahun)
  
      return matchesSearch && matchesStatus;
    });
  
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentPhotoMeters = filteredPhotoMeters.slice(indexOfFirstItem, indexOfLastItem);
    let totalPages = itemsPerPage > 0 ? Math.ceil(filteredPhotoMeters.length / itemsPerPage) : 0;
    const pageNumbers = totalPages > 0 ? Array.from({ length: totalPages }, (_, i) => i + 1) : [];
  
    const initDataPhotoMeter = async () => { 
        setLoading(true); // Set loading state ke true sebelum memulai fetch
        try {
            const res = await fetchGetPhotoMeterAll(); // Panggil API
            if (res.status === 200 && Array.isArray(res.data)) {
  
              const today = new Date();
              today.setHours(0, 0, 0, 0);
  
                const processedData = res.data.map((item: any) => ({
                    no: 0,
                    nama: item.NAMA || "Tidak ada data",
                    nsb: item.NSB || "Tidak ada data",
                    kecamatan: item.KECAMATAN || "Tidak ada data",
                    desa: item.DESA || "Tidak ada data",
                    klasf: item.KLASF || "Tidak ada data",
                    pelanggan: item.PELANGGAN || "Tidak ada data",
                    status: item.STATUS || "Tidak ada data",
                    pakai: item.PAKAI || "Tidak ada data",
                    tahun: item.TAHUN || "Tidak ada data",
                }));

                const sortedData = processedData;
                setPhotoMeterData(sortedData);
            } else {
                console.error("Invalid response data:", res.data);
                setPhotoMeterData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setPhotoMeterData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleShowDetail = (pm : PhotoMeterItem) => {
        setSelectedPhotoMeter(pm);
        setShowDetailModal(true);
    }

    useEffect(() => {
      initDataPhotoMeter();
      setItemsPerPage(Number(statusLength === 'all' ? photoMeterData.length : statusLength))
    }, []);

    return (
      <>
        {/* Controls 1*/}
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-center">
                {/* Search input - spans banyak kolom di layar md+ */}
                {/* <div className="col-span-1 md:col-span-6">
                <div className="relative">
                    <input
                    type="text"
                    placeholder="Cari Nama"
                    value={uniqueNama.includes(statusFilter.nama) ? statusFilter.nama : ''}
                    onChange={(e) => setStatusFilter({ ...statusFilter, nama: e.target.value })}
                    className="w-full pl-4 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                </div>
                </div> */}

                {/* NSB */}
                <div className="col-span-1 md:col-span-2">
                <div className="relative">
                    <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <select
                    value={statusFilter.nsb}
                    onChange={(e) => setStatusFilter({ ...statusFilter, nsb: e.target.value })}
                    className="pl-10 pr-3 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                    <option value="all">NSB</option>
                    {uniqueNsb.map((nsb, idx) => (
                        <option value={nsb} key={idx}>{nsb}</option>
                    ))}
                    </select>
                </div>
                </div>

                {/* Pelanggan */}
                <div className="col-span-1 md:col-span-2">
                <div className="relative">
                    <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <select
                    value={statusFilter.status}
                    onChange={(e) => setStatusFilter({ ...statusFilter, status: e.target.value })}
                    className="pl-10 pr-3 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                    <option value="all">Pelanggan</option>
                    {uniqueStatus.map((item, idx) => (
                        <option value={item} key={idx}>{item}</option>
                    ))}
                    </select>
                </div>
                </div>

                {/* Klas */}
                <div className="col-span-1 md:col-span-2">
                  <div className="relative">
                      <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                      <select
                      value={statusFilter.klasf}
                      onChange={(e) => setStatusFilter({ ...statusFilter, klasf: e.target.value })}
                      className="pl-10 pr-3 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      >
                      <option value="all">Klas</option>
                      {uniqueKlas.map((klasf, idx) => (
                          <option value={klasf} key={idx}>{klasf}</option>
                      ))}
                      </select>
                  </div>
                </div>

                {/* Status (pakai) */}
                <div className="col-span-1 md:col-span-2">
                <div className="relative">
                    <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <select
                    value={statusFilter.pelanggan}
                    onChange={(e) => setStatusFilter({ ...statusFilter, pelanggan: e.target.value })}
                    className="pl-10 pr-3 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                    <option value="all">Status</option>
                    {uniquePelanggan.map((item, idx) => (
                        <option value={item} key={idx}>{item}</option>
                    ))}
                    </select>
                </div>
                </div>

                {/* Kecamatan */}
                <div className="col-span-1 md:col-span-2">
                <div className="relative">
                    <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <select
                    value={statusFilter.kecamatan}
                    onChange={(e) => setStatusFilter({ ...statusFilter, kecamatan: e.target.value })}
                    className="pl-10 pr-3 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                    <option value="all">Kecamatan</option>
                    {uniqueKecamatan.map((kecamatan, idx) => (
                        <option value={kecamatan} key={idx}>{kecamatan}</option>
                    ))}
                    </select>
                </div>
                </div>

                {/* Desa */}
                <div className="col-span-1 md:col-span-2">
                <div className="relative">
                    <Filter className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <select
                    value={statusFilter.desa}
                    onChange={(e) => setStatusFilter({ ...statusFilter, desa: e.target.value })}
                    className="pl-10 pr-3 py-2 border border-gray-300 rounded-lg w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                    <option value="all">Desa</option>
                    {uniqueDesa.map((desa, idx) => (
                        <option value={desa} key={idx}>{desa}</option>
                    ))}
                    </select>
                </div>
                </div>
            </div>
        </div>

        {/* Controls 2*/}
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
            <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
              {/* Filter */}
              <button 
                onClick={initDataPhotoMeter}
                disabled={loading}
                className="flex items-center px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
                <RotateCcw className={`w-4 h-4 mr-2 ${loading ? "animate-spin" : ""}`} />
                {loading ? "Memuat..." : "Muat Ulang"}
              </button>

              <ExportCSV  data={selectedPhotoMeter}/>
            </div>

            <div className="flex space-x-3">
              {/* Search */}
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="text"
                  placeholder="Cari nama atau NIK..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full md:w-64"
                />
              </div>

              {/* Length*/}
              <div className="relative">
                <ListOrdered className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <select
                  value={statusLength}
                  onChange={(e) => {setStatusLength(e.target.value); setItemsPerPage(Number(e.target.value === 'all' ? photoMeterData.length : e.target.value))}}
                  className="pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full md:w-48"
                >
                  <option value="10">10</option>
                  <option value="50">50</option>
                  <option value="100">100</option> 
                  <option value="500">500</option>
                  <option value="all">Tampil Semua</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Employee Table */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="overflow-x-auto">
              <table className="table-auto min-w-full max-w-screen-lg divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    NO
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    NAMA
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    NSB
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    KECAMATAN
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    DESA
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    KLASF
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    PELANGGAN
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    STATUS
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    PAKAI
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    TAHUN
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                  {
                    loading? 
                    <>
                      <tr>
                        <td colSpan={18} className="text-center py-4 text-gray-500">
                          Sedang Loading . . .
                        </td>
                      </tr>
                    </>
                    :
                    <>
                      <RenderTablePhotoMeterPelanggan filteredData={currentPhotoMeters} onOpenDetail={handleShowDetail} />
                    </>
                  }
              </tbody>
            </table>
          </div>
        </div>
  
        {/* Pagination */}
        <div className="mt-6 flex items-center justify-between">
        <div className="text-sm text-gray-700">
          Menampilkan <span className="font-medium">{currentPage}</span> hingga{' '}
          <span className="font-medium">{statusLength === "all" ? photoMeterData.length : statusLength}</span> dari{' '}
          <span className="font-medium">{photoMeterData.length}</span> karyawan
          <span className="font-medium">( Dari Sortir {filteredPhotoMeters.length} )</span>
        </div>
        <div className="flex space-x-2">
          <button 
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(1)}
          className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
          First
          </button>
          <button 
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(prev => prev - 1)}
          className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
          Previous
          </button>
          
          {pageNumbers
          .slice(
            Math.max(0, currentPage - 3), 
            Math.min(currentPage + 2, totalPages)
          )
          .map((page) =>( 
            <button 
            key={page}
            onClick={() => setCurrentPage(page)}
            className={`px-3 py-1 rounded ${ currentPage === page ? "bg-blue-500 text-white" : "bg-gray-200" }`}>
            {page}
            </button>
          ))}
          
          <button 
              disabled={currentPage === Math.ceil(filteredPhotoMeters.length / itemsPerPage)}
              onClick={() => setCurrentPage(prev => prev + 1)}
              className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
              Next
          </button>
          <button 
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(totalPages)}
              className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
              Last
          </button>
        </div>
        </div>

        {showDetailModal && <DetailPreviewModal pelangganPMDetail={selectedPhotoMeter} stateShowModal={setShowDetailModal} />}
      </>
    )
}

const openImage = (photo : string) => {
    window.open(photo, '_blank');
}

export const ExportCSV = (data : any) => {
    return (
        <button 
            onClick={async () => {
                try {
                   const response = await CSV(data, "Export_PhotoMeter");
                } catch (error) {
                    console.error("Error exporting CSV:", error);
                }
            }}
            className="flex items-center px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
            <Download className="w-4 h-4 mr-2" />
            { "Export" }
        </button>
    )
}

export const RenderTablePhotoMeterPelanggan = ({ filteredData, onOpenDetail }: { 
    filteredData: PhotoMeterItem[] | null; 
    onOpenDetail : (employee: PhotoMeterItem) => void;
}) => (
  <>
    {
      filteredData && filteredData.length > 0 ? (
        filteredData.map((plg, idx) => (
          <tr key={idx} className="hover:bg-gray-50 transition-colors">
            <td className="px-6 py-4 whitespace-nowrap">
                {idx + 1}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {plg.nama}
            </td>
            <td className="px-6 py-4 whitespace-nowrap">
                {plg.nsb}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {plg.kecamatan}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {plg.desa}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {plg.klasf}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {plg.pelanggan}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {plg.status}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {plg.pakai}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {plg.tahun}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                <button onClick={() => { onOpenDetail(plg) }} className="flex items-center px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
                ><Settings /></button>
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={18} className="text-center py-4 text-gray-500">
            Tidak ada data
          </td>
        </tr>
      )
    }
  </>
);

export const DetailPreviewModal = ({ pelangganPMDetail, stateShowModal }: { 
    pelangganPMDetail: PhotoMeterItem | null; 
    stateShowModal: (show: boolean) => void | false;
}) => {
    const [data, setData] = useState<any>({ data: [] });
    const [loadingData, setLoadingData] = useState<boolean>(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoadingData(true);
            const result = await fetchGetPhotoMeterTagihanAll(pelangganPMDetail?.nsb || '');
            setData(result);
            setLoadingData(false);
        };
        fetchData();
    }, [pelangganPMDetail]);

    const sortedData = data.data.slice().sort((a : any, b : any) => {
        if (a.TAHUN !== b.TAHUN) return b.TAHUN - a.TAHUN;
        return b.BULAN - a.BULAN;
      });

    return(
        <>
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl mx-4 p-6 overflow-hidden">
                <div className="flex items-center justify-between mb-6">
                    <div>
                        <h3 className="text-xl font-semibold text-gray-800">Detail Pelanggan : {pelangganPMDetail?.nama} </h3>
                        <div className="text-xl font-semibold text-gray-500">Pelanggan : {pelangganPMDetail?.pelanggan}</div>
                        <div className="text-xl font-semibold text-gray-500">Klasf : {pelangganPMDetail?.klasf}</div>
                    </div>
                    <button
                        onClick={() => stateShowModal(false)}
                        className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                        >
                        ✕
                    </button>
                </div>
            
            <div className="space-y-4 overflow-y-auto max-h-[70vh]">
                <table className="table-auto min-w-full max-w-screen-lg divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">NO</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">PERIODE</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">KLASF</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">MLALU</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">MKINI</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
                        </tr>
                    </thead>
                    <tbody>
                            { sortedData && sortedData.length > 0 ? (
                                sortedData.map((tagihan: any, idx: number) => (
                                <tr key={idx} className="hover:bg-gray-100 transition-colors">
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{idx + 1}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.BULAN} - {tagihan.TAHUN}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.KLAS}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.MLALU}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{tagihan.MKINI}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">

                                        {tagihan.photo == null || tagihan.photo == '' ?  
                                            <span className="text-red-500">Tidak ada foto</span>
                                            :
                                            <button onClick={() => { 
                                                if (tagihan.photo) {
                                                  const url_photo = `http://192.168.1.91/${tagihan.TAHUN}/${tagihan.BULAN}/${tagihan.photo}`;
                                                  console.log(url_photo);
                                                  openImage(url_photo);
                                                }
                                            }} className="flex items-center px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors">
                                                <Image />
                                                {tagihan.photo}
                                            </button>
                                        }
                                    </td>
                                </tr>
                                ))
                            ) : (
                                <tr>
                                    { loadingData ?  
                                        <td colSpan={5} className="text-center py-4 text-gray-500">
                                            Sedang Loading . . . 
                                        </td>
                                        :
                                        <td colSpan={5} className="text-center py-4 text-gray-500">
                                            Tidak ada data tagihan 
                                        </td>
                                    }
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>

            </div>
        </div>
        </>
    );
}